import { observable, action, runInAction } from "mobx";
import { message } from "antd";

import RootStore from "app/RootStore";
import ConsultationService from "contexts/consultations/ConsultationService";

interface Pagination {
  pageSize: number;
  currentPage: number;
  totalSize?: number;
}

export default class LawyerStore {
  @observable public loading = false;

  @observable public dataListConsultation: ResConsultation[] = [];
  @observable public consultationCount = 0;

  private rootStore: RootStore;
  private consultationService: ConsultationService;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.consultationService = new ConsultationService();
  }

  @action
  async listConsultation(params: SearchParamsConsultation) {
    try {
      const res = await this.consultationService.getConsultations(params);
      runInAction(() => {
        this.consultationCount = res.count;
        this.dataListConsultation = res.results;
      });
      return res;
    } catch (err) {
      message.error(err.message || "There was a problem.");
      throw err;
    }
  }

  async listConsultationAll(params: SearchParamsConsultation) {
    try {
      const res = await this.listConsultation({
        ...params,
        page: 1,
        size: this.consultationCount,
      });
      return res;
    } catch (err) {
      message.error(err.message || "There was a problem.");
      throw err;
    }
  }
}
